<template>
    <svg id="pageSvg" :width="canvasWidth" :height="canvasHeight" :viewBox="viewBox">
        <comp v-for="(comp, index) in canvas" :key="comp.id" :data="comp" :z="index"></comp>
		<g> {{new Date().getTime()}}
			<line v-for="(item,index) in positionList" :key="index"
			:x1="item[0][0]" 
			:y1="item[0][1]" 
			:x2="item[1][0]" 
			:y2="item[1][1]" 
			style="stroke:rgb(61, 248, 4);stroke-width:2" />
		</g>
    </svg>
</template>

<script>
	export default {
		props: {
			designWidth: Number,
			designHeight: Number,
			canvasWidth: Number,
			canvasHeight: Number,
		},
		computed: {
			canvas(){
				return this.$store.state.canvas||[]
			},
			viewBox() {
				return `0 0 ${this.designWidth} ${this.designHeight}`
			},
			positionList() {
				//刻度线点集
				// localStorage.setItem('computed' ,new Date().getTime()-localStorage.getItem('action-over-time'))
				return this.$store.state.positionList
			},
			// pressed() {
			// 	return this.$store.state.input.keypressed
			// },
			// mask() {
			// 	return this.$store.state.mask
			// }
		},
	}
</script>